import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'core.nav-header',
    excludes: { country: ['IL']},
    options: {
      variant: 'positive'
    },
  },
  {
    feature: 'core.nav-header',
    country: ['IL'],
    options: {
      variant: 'negative'
    },
  },
] as IAppConfiguration[];
